import React from 'react';
import { Form, Container, Icon, Dimmer, Loader, Confirm } from 'semantic-ui-react';
import { ProviderModel } from '../../../entities/provider.model';
import MyForm from './form';
import { ImageModel } from '../../../entities/image.model';
import ImageOnS3 from '../../../components/imageOnS3/imageOnS3.component';
import MyFormState from './MyFormState';
import { Redirect } from 'react-router-dom';

interface FormProps {
    match: any,
    history: any
}

interface ProviderFormState extends MyFormState {
    disableModalOpen: boolean
    disableModalLoading: boolean
    disableModalSubmitting: boolean
    disablePreviewProductCount: number
}

class ProviderForm extends MyForm<FormProps, ProviderFormState> {
    entity = "provider";

    constructor(props: any) {
        super(props);
        this.state = {
            model: new ProviderModel(),
            successMsg: "",
            errorMsg: "",
            loading: false,
            editing: false,
            editingSlug: false,
            slugValid: true,
            imageObj: ImageModel.empty(),
            imageObjs: { lg: ImageModel.empty(), sm: ImageModel.empty(), xs: ImageModel.empty(),
                image1: ImageModel.empty(), image2: ImageModel.empty(), image3: ImageModel.empty(),
                image4: ImageModel.empty(), image5: ImageModel.empty(), image6: ImageModel.empty()
            },
            redirect: "",
            disableModalOpen: false,
            disableModalLoading: false,
            disableModalSubmitting: false,
            disablePreviewProductCount: 0,
        }
    }

    readCheckboxChecked(e: any, data?: { checked?: boolean }): boolean {
        if (data && typeof data.checked === 'boolean') {
            return data.checked;
        }
        return Boolean(e && e.target && e.target.checked);
    }

    onProviderActiveChange = (e: any, data?: { checked?: boolean }) => {
        const checked = this.readCheckboxChecked(e, data);
        if (this.state.editing && this.state.model.id != null && !checked) {
            this.openDisableModal();
            return;
        }
        const model: any = this.state.model;
        model.active = checked;
        this.setState({ model: model });
    };

    openDisableModal = () => {
        const token = localStorage.getItem('adminToken');
        const id = this.props.match.params.id;
        if (!token || token === 'undefined' || !id) {
            this.setState({ redirect: this.loginUrl });
            return;
        }
        this.setState({
            disableModalOpen: true,
            disableModalLoading: true,
            disableModalSubmitting: false,
            disablePreviewProductCount: 0,
            errorMsg: '',
        });
        fetch(`${process.env.REACT_APP_API_URL}mongol/provider/${id}/disable-preview`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                Authorization: token,
                'Content-Type': 'application/json',
            },
        })
            .then((res) => {
                if (res.status === 401) {
                    this.setState({
                        redirect: this.loginUrl,
                        disableModalOpen: false,
                        disableModalLoading: false,
                    });
                    return Promise.reject(new Error('unauthorized'));
                }
                return res.json().catch(() => ({}));
            })
            .then((body: any) => {
                if (!body || body.activeProductCount === undefined) {
                    this.setState({
                        disableModalLoading: false,
                        errorMsg: 'Урьдчилан тоолох боломжгүй байна.',
                        disableModalOpen: false,
                    });
                    return;
                }
                this.setState({
                    disableModalLoading: false,
                    disablePreviewProductCount: Number(body.activeProductCount) || 0,
                });
            })
            .catch((err) => {
                if (err && err.message === 'unauthorized') {
                    return;
                }
                this.setState({
                    disableModalLoading: false,
                    errorMsg: 'Сүлжээний алдаа',
                    disableModalOpen: false,
                });
            });
    };

    closeDisableModal = () => {
        if (this.state.disableModalSubmitting) {
            return;
        }
        this.setState({
            disableModalOpen: false,
            disableModalLoading: false,
        });
    };

    confirmDisableProvider = () => {
        if (this.state.disableModalLoading) {
            return;
        }
        const model: any = this.state.model;
        model.active = false;
        this.setState(
            {
                disableModalOpen: false,
                disableModalSubmitting: false,
                disableModalLoading: false,
                model: model,
                errorMsg: '',
            },
            () => void this.save()
        );
    };

    validate(): boolean {
        this.setState({ successMsg: "" });
        if (!this.state.model.name) {
            this.setState({ errorMsg: "Байгууллагын нэрийг оруулна уу." });
            return false;
        }
        if (!this.state.model.register) {
            this.setState({ errorMsg: "Байгууллагын регистр оруулна уу." });
            return false;
        }
        if (!this.state.model.email) {
            this.setState({ errorMsg: "Байгууллагын имэйл оруулна уу." });
            return false;
        }
        if (!this.validateEmail(this.state.model.email)) {
            this.setState({ errorMsg: "Байгууллагын имэйл буруу форматтай байна." });
            return false;
        }
        if (!this.state.model.phone) {
            this.setState({ errorMsg: "Байгууллагын утасны дугаар оруулна уу." });
            return false;
        }
        if (!this.validatePhone(this.state.model.phone)) {
            this.setState({ errorMsg: "Байгууллагын утасны дугаар буруу форматтай байна." });
            return false;
        }
        if (!this.state.editing) {
            if (!this.state.model.contactName) {
                this.setState({ errorMsg: "Холбогдох хүний нэр оруулна уу" });
                return false;
            }
            if (!this.state.model.contactRole) {
                this.setState({ errorMsg: "Холбогдох хүний албан тушаал оруулна уу" });
                return false;
            }
            if (!this.state.model.contactEmail) {
                this.setState({ errorMsg: "Холбогдох хүний имэйл оруулна уу" });
                return false;
            }
            if (!this.state.model.contactPhone) {
                this.setState({ errorMsg: "Холбогдох хүний утасны дугаар оруулна уу" });
                return false;
            }
            if (!this.validatePhone(this.state.model.contactPhone)) {
                this.setState({ errorMsg: "Холбогдох хүний утасны дугаар буруу форматтай байна." });
                return false;
            }
        }
        if (!this.state.model.town) {
            this.setState({ errorMsg: "Хот оруулна уу" });
            return false;
        }
        if (!this.state.model.district) {
            this.setState({ errorMsg: "Дүүрэг оруулна уу" });
            return false;
        }
        if (!this.state.model.unit) {
            this.setState({ errorMsg: "Хороо оруулна уу" });
            return false;
        }
        if (!this.state.model.street) {
            this.setState({ errorMsg: "Дэлгэрэнгүй хаяг оруулна уу" });
            return false;
        }
        if (this.state.model.id !== undefined) {
            if (this.state.model.name === this.originalModel.name
                && this.state.model.register === this.originalModel.register
                && this.state.model.info === this.originalModel.info
                && this.state.model.email === this.originalModel.email
                && this.state.model.phone === this.originalModel.phone
                && this.state.model.contactName === this.originalModel.contactName
                && this.state.model.contactPhone === this.originalModel.contactPhone
                && this.state.model.contactEmail === this.originalModel.contactEmail
                && this.state.model.contactRole === this.originalModel.contactRole
                && (!this.state.imageObj.file && this.state.model.imageUrl === this.originalModel.imageUrl)
                && this.state.model.approved === this.originalModel.approved
                && this.state.model.town === this.originalModel.town
                && this.state.model.district === this.originalModel.district
                && this.state.model.unit === this.originalModel.unit
                && this.state.model.street === this.originalModel.street
                && this.state.model.zipcode === this.originalModel.zipcode
                && this.state.model.active === this.originalModel.active
                ) {
                this.setState({ errorMsg: "Өөрчлөлт байхгүй байна" });
                return false;
            }
        }
        this.setState({ errorMsg: "" });
        return true;
    }

    render() {
        if (this.state.redirect) {
            return <Redirect to={this.state.redirect}/>
        }
        return (
            <Container>
                <Dimmer active={this.state.loading} inverted>
                    <Loader size='medium'></Loader>
                </Dimmer>
                <h2>{!this.state.editing ? 'Шинэ' : ''} Нийлүүлэгч</h2>
                <Form widths='equal'>
                    <Form.Group>
                        { this.state.successMsg ? <div className="success-msg">{this.state.successMsg}</div> : null }
                        { this.state.errorMsg ? <div className="error-msg">
                            <Icon name="warning circle"/>
                        {this.state.errorMsg}</div> : null }
                    </Form.Group>
                    <Form.Group widths='equal'>
                        <div data-testid="provider-name-input">
                            <Form.Field label='Байгууллагын нэр' required control='input' value={this.state.model.name} onChange={this.onNameChange} />
                        </div>
                    </Form.Group>
                    <Form.Group widths='equal'>
                        <div data-testid="provider-register-input">
                            <Form.Field label='Байгууллагын регистр' required control='input' value={this.state.model.register} onChange={this.onRegisterChange} />
                        </div>
                    </Form.Group>
                    <Form.Group widths='equal'>
                        <div data-testid="provider-email-input">
                            <Form.Field label='Байгууллагын имэйл' control='input' value={this.state.model.email} onChange={this.onEmailChange} />
                        </div>
                    </Form.Group>
                    <Form.Group widths='equal'>
                        <div data-testid="provider-phone-input">
                            <Form.Field label='Байгууллагын утасны дугаар' required control='input' value={this.state.model.phone} onChange={this.onPhoneChange} />
                        </div>
                    </Form.Group>
                    <Form.Group>
                        <Form.TextArea label='Товч танилцуулга' width="16" value={this.state.model.info} onChange={this.onInfoChange}/>
                    </Form.Group>

                    { this.state.editing ? null : <React.Fragment>
                    <Form.Group>
                        <p>
                            <Icon name="info circle" color="blue"/>
                            Харилцах хүний имэйл хаягт тус компаний бүтээгдэхүүн агуулахыг удирдах аккаунт үүсч, нууц үг үүсгэх линк бүхий имэйл илгээгдэнэ.
                        </p>
                    </Form.Group>
                    <Form.Group widths='equal'>
                        <div data-testid="provider-contact-name-input">
                            <Form.Field required label='Харилцах хүний нэр' control='input' value={this.state.model.contactName} onChange={this.onContactNameChange} />
                        </div>
                    </Form.Group>
                    <Form.Group widths='equal'>
                        <div data-testid="provider-contact-role-input">
                            <Form.Field required label='Харилцах хүний албан тушаал' control='input' value={this.state.model.contactRole} onChange={this.onContactRoleChange} />
                        </div>
                    </Form.Group>
                    <Form.Group widths='equal'>
                        <div data-testid="provider-contact-email-input">
                            <Form.Field required label='Имэйл' control='input' type="email" value={this.state.model.contactEmail} onChange={this.onContactEmailChange} />
                        </div>
                    </Form.Group>
                    <Form.Group widths='equal'>
                        <div data-testid="provider-contact-phone-input">
                            <Form.Field required label='Утасны дугаар' control='input' value={this.state.model.contactPhone} onChange={this.onContactPhoneChange} />
                        </div>
                    </Form.Group>
                    </React.Fragment> }
                    <Form.Group>
                        <h3>Байгууллагын хаяг</h3>
                    </Form.Group>
                    <Form.Group>
                        <div data-testid="provider-town-input">
                            <Form.Input label='Хот' required value={this.state.model.town} onChange={this.onTownChange} />
                        </div>
                    </Form.Group>
                    <Form.Group>
                        <div data-testid="provider-district-input">
                            <Form.Input label='Дүүрэг' required value={this.state.model.district} onChange={this.onDistrictChange} />
                        </div>
                    </Form.Group>
                    <Form.Group>
                        <div data-testid="provider-unit-input">
                            <Form.Input label='Хороо' required value={this.state.model.unit} onChange={this.onAddressUnitChange} />
                        </div>
                    </Form.Group>
                    <Form.Group>
                        <div data-testid="provider-street-input">
                            <Form.TextArea label='Дэлгэрэнгүй хаяг' required value={this.state.model.street} onChange={this.onStreetChange} />
                        </div>
                    </Form.Group>
                    <Form.Group>
                        <Form.Input label='Зип код' value={this.state.model.zipcode} onChange={this.onZipCodeChange} />
                    </Form.Group>
                    <Form.Group>
                        <Form.Checkbox checked={this.state.model.approved} onChange={this.onApprovedChange} label='Зөвшөөрсөн' />
                    </Form.Group>
                    <Form.Group>
                        <div data-testid="provider-active-checkbox">
                            <Form.Checkbox
                                checked={this.state.model.active}
                                onChange={this.onProviderActiveChange}
                                label='Идэвхитэй'
                            />
                        </div>
                    </Form.Group>
                    <Form.Group className="flex-space-between">
                        <div className="field">
                            <label>Лого (1x1)</label>
                        </div>
                        { this.state.imageObj.uploaded ?
                        <div className={ this.state.imageObj.showOriginal ? "flex-space-between" : "hidden-div"}>
                            <ImageOnS3 imgKey={this.state.model.imageUrl} width='50px' height='50px'/>
                            <Icon className="cursor margin-10" name="trash" size='large' onClick={() => this.toggleImage('imageUrl')} />
                        </div> : null }
                        <Icon className={this.state.imageObj.uploaded && !this.state.imageObj.showOriginal ? "" : "hidden-div"} name='redo' size='large' onClick={() => this.toggleImage('imageUrl')}/>
                        <Form.Input control='input' type="file" accept="image/png, image/jpeg" onChange={this.handleImageChange} />
                    </Form.Group>
                    <div data-testid="provider-save-button">
                        <Form.Button disabled={this.state.loading} onClick={() => this.save()}>Хадгалах</Form.Button>
                    </div>
                </Form>

                <Confirm
                    open={this.state.disableModalOpen}
                    header="Нийлүүлэгчийг идэвхгүй болгох"
                    cancelButton="Болих"
                    confirmButton="Тийм, идэвхгүй болгох"
                    onCancel={this.closeDisableModal}
                    onConfirm={this.confirmDisableProvider}
                    closeOnDimmerClick={!this.state.disableModalSubmitting}
                    content={
                        this.state.disableModalLoading ? (
                            <p data-testid="provider-disable-loading">Тоолж байна…</p>
                        ) : (
                            <div style={{ padding: '0 25px' }} data-testid="provider-disable-modal-content">
                                <p>
                                    <strong>{this.state.model.name}</strong> нийлүүлэгчийг идэвхгүй болгох үед{' '}
                                    <strong data-testid="provider-disable-active-count">{this.state.disablePreviewProductCount}</strong> идэвхтэй бараа автоматаар идэвхгүй болно.
                                </p>
                                <p>Үргэлжлүүлэх үү?</p>
                            </div>
                        )
                    }
                />
            </Container>
        );
    }
}

export default ProviderForm;